<h1 mat-dialog-title>Etes-vous sûr de vouloir supprimer le projet ?</h1>
<form (ngSubmit)="myForm.form.valid && onSubmit()" #myForm="ngForm" fxLayout="row wrap" fxLayoutAlign="space-around center">
  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around center">
    <button mat-button mat-dialog-close type="button">Annuler</button>
    <button mat-button [mat-dialog-close]="true" color="warn">Supprimer</button>
  </div>
</form>
